import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import { useDataRefresh, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';

import messages from './WMICAddPayoutComponent.messages';
import metadata from './WMICAddPayoutComponent.metadata.json5';

function WMICAddPayoutComponent(props) {
    const {
        id,
        selectedPriorLoss,
        value: selectedPayout,
        claimPaymentTypeAvailableValues,
        onValidate,
        isEditing,
        showErrors,
    } = props;
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    const { refreshData } = useDataRefresh();
    const translator = useContext(TranslatorContext);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
        return () => (onValidate ? onValidate(true, id) : undefined);
    }, [isComponentValid, onValidate, id]);

    const getCauseOfLossAvailableValues = () => {
        const availableCauseOfLosses =
            isEditing && selectedPriorLoss?.value?.isReadOnly === false
                ? selectedPayout?.type?.aspects?.availableValues?.filter(causeOfLoss =>
                    claimPaymentTypeAvailableValues.includes(causeOfLoss.code)
                  )
                : selectedPayout?.type?.aspects?.availableValues;

        return availableCauseOfLosses
            ?.map(causeOfLoss => ({
                code: causeOfLoss.code,
                name: translator({ id: causeOfLoss.name }),
            }))
            ?.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? '')) ?? [];
    };

    const overrideProps = {
        '@field': {
            parentNode: selectedPayout,
            readOnly: selectedPriorLoss.value.isReadOnly || !isEditing,
        },
        causeOfLoss: {
            availableValues: getCauseOfLossAvailableValues(),
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={selectedPayout}
            overrideProps={overrideProps}
            onModelChange={() => refreshData()}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />
    );
}

WMICAddPayoutComponent.propTypes = {
    id: PropTypes.string.isRequired,
    selectedPriorLoss: PropTypes.shape({}).isRequired,
    selectedPayout: PropTypes.shape({}).isRequired,
    claimPaymentTypeAvailableValues: PropTypes.array.isRequired,
    onValidate: PropTypes.func.isRequired,
    isEditing: PropTypes.bool.isRequired,
    showErrors: PropTypes.bool.isRequired,
};

export default WMICAddPayoutComponent;
